import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BookBetPage } from './book-bet';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    BookBetPage,
  ],
  imports: [
    IonicPageModule.forChild(BookBetPage),
    TranslateModule
  ],
})
export class BookBetPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/book-bet/book-bet.module.ts